export type Salon = {
  title: string;
  id: string;
  sapId: string;
  salonStatus: string;
  businessType: string;
  salonPod: Record<string, string>;
  salonRegion: Record<string, string>;
  storeRegion: string;
  sdpEmailAddress: string;
  hierarchyLevel: string;
  updateTime: Date;
  classification: string;
  mAddress1: string;
  mAddress2: string;
  mCity: Record<string, string>;
  mState: Record<string, string>;
  mSt: Record<string, string>;
  mCountry: Record<string, string>;
  mZip: string;
  notes: string;
  photos: string[];
};

export const SalonInfoMap = {
  classification: 'classification',
  salonRegion: 'region',
  salonPod: 'pod',
  sapId: 'sapId',
  salonStatus: 'status',
  businessType: 'type',
};
